// @flow

import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import basketReducer from './basket_reducer';
import loginReducer from './login_reducer';
import errorMessageReducer from './error_messages_reducer';
import payment from './payment_reducer';
import infoReducer from './info_reducer';
import userReducer from './user_reducer';

export default combineReducers({
  form: formReducer,
  basket: basketReducer,
  errorMessages: errorMessageReducer,
  login: loginReducer,
  info: infoReducer,
  user: userReducer,
  payment
});



// WEBPACK FOOTER //
// ./src/reducers/index.js